module.exports = __webpack_public_path__ + "img/delete-document.a82aabad.svg";